import { render, staticRenderFns } from "./PayrollList.vue?vue&type=template&id=735801fc&scoped=true"
import script from "./PayrollList.vue?vue&type=script&lang=js"
export * from "./PayrollList.vue?vue&type=script&lang=js"
import style0 from "./PayrollList.vue?vue&type=style&index=0&id=735801fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735801fc",
  null
  
)

export default component.exports